// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kd-c";
export var backButton = "_kd-4";
export var backIcon = "_kd-5";
export var chevronShortcut = "_kd-6";
export var container = "_kd-1";
export var editor = "_kd-8";
export var editorWrapper = "_kd-7";
export var prefix = "_kd-2";
export var searchIcon = "_kd-3";
export var suffix = "_kd-9";
export var suffixContent = "_kd-a";
export var suffixText = "_kd-b";
export var wrapper = "_kd-0";